import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    name: yup
      .string()
      .trim()
      .required('Name is required')
      .min(1, 'Name must be at least 1 character'),
    url: yup
      .string()
      .trim()
      .required('URL is required')
      .min(1, 'URL must be at least 1 character'),
  })
  .required()

const resAddPage = yupResolver(schema)

export default resAddPage
